
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { contractOrderList, cancelOrder } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
type: 0,
holdList: [],
trade_type: ""
}
},
computed:{
...mapState(['token'])
},
created(){
this.trade_type = this.$route.query.trade_type
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()
contractOrderList({token: this.token,status: this.type, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.holdList = res.data || []
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
},
timeChange(time) {


if (typeof time === 'string' && time.includes('-')) {
return time;
}

var date = new Date(time*1000);
var Y = date.getFullYear() + '-';
var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
var D = date.getDate() <10 ? '0'+date.getDate() + ' ' : date.getDate()+' ';
var h = date.getHours() + ':';
var m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes() ;
var s = date.getSeconds();
return Y+M+D+h+m;
},
cancelOrder(id){
var that = this

this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行撤单操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
cancelOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getData()

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/perpetualHistory.vue